import type { DummyFoods } from './dummyFoods'

export const cheese: DummyFoods = {
  Cheese: {
    American: ['American cheese'],
    Asiago: ['Asiago cheese'],
    Blue: ['Blue cheese'],
    Brie: ['Brie cheese'],
    'Buffalo cheese': ['Buffalo mozzarella cheese'],
    'Buffalo milk': ['Buffalo milk cheese'],
    Camembert: ['Camembert cheese'],
    Cheddar: ['Cheddar cheese'],
    Chihuahua: ['Chihuahua cheese'],
    Colby: ['Colby cheese'],
    Cotija: ['Cotija cheese'],
    Cream: ['Cream cheese'],
    Edam: ['Edam cheese'],
    Emmentaler: ['Emmentaler cheese'],
    Epoisses: ['Epoisses cheese'],
    Feta: ['Feta cheese'],
    Fontina: ['Fontina cheese'],
    Goat: ['Goat cheese'],
    Gorgonzola: ['Gorgonzola cheese'],
    Gouda: ['Gouda cheese'],
    Gruyere: ['Gruyere cheese'],
    Havarti: ['Havarti cheese'],
    Jarlsberg: ['Jarlsberg cheese'],
    Manchego: ['Manchego cheese'],
    Mexican: ['Mexican blend'],
    Monterey: ['Monterey Jack cheese'],
    Mozzarella: ['Mozzarella cheese'],
    Muenster: ['Muenster cheese'],
    Neufchatel: ['Neufchatel cheese'],
    Parmesan: ['Parmesan cheese'],
    Pecorino: ['Pecorino Romano cheese'],
    Provolone: ['Provolone cheese'],
    Ricotta: ['Ricotta cheese'],
    Roquefort: ['Roquefort cheese'],
    Stilton: ['Stilton cheese'],
    Swiss: ['Swiss cheese'],
  },
}
